import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import pa1 from "../Images/pa1.jpg";
import pa3 from "../Images/pa3.png";
import pa5 from "../Images/pa5.jpg";
import pa4 from "../Images/pa4.jpg";
import pa6 from "../Images/pa6.png";
import { project_name } from "../Config/config";

export default function ProductivityAnalysis() {
  return (
    <>
      {/* <!-- Required meta tags --> */}
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="description"
        content="Save time in gathering information, save time in making smart decisions, save time from bad strategic decisions, save time for the more enjoyable parts of business life"
      />
      <meta property="og:title" content="Productivity Analysis" />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://entelipro.com/productivityanalysis"
      />
      <meta
        property="og:image"
        content="https://www.entelipro.com/static/media/pa1.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://www.entelipro.com/static/media/pa1.jpg"
      />
      <meta property="og:site_name" content="entelipro.com" />
      <meta
        property="og:description"
        content="Save time in gathering information, save time in making smart decisions, save time from bad strategic decisions, save time for the more enjoyable parts of business life"
      />
      <meta property="og:locale" content="en_US" />

      <script type="application/ld+json">
        `
        {`"@context":"https://schema.org","@type":"WebPage","name":"Productivity Analysis",
            "logo":{"@type":"ImageObject","url":"https://www.entelipro.com/web/dist/img/u.png"},"url":"https://www.entelipro.com/productivityanalysis"`}
        `
      </script>

      <title>
        Productivity Analysis| Best CRM Software | Indsac Crm :: entelipro.com
      </title>
      <Navbar />

      {/* <!-- breadcrumbs --> */}
      <section class="w3l-inner-banner-main">
        <div class="about-inner inner2">
          <div class="container seen-w3">
            <ul class="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span class="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/services">
                  Services{" "}
                  <span class="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li class="active">Productivity Analysis</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- breadcrumbs //--> */}
      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="main-titles-head text-center">
              <h3 class="header-name">Productivity Analysis</h3>
            </div>
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={pa1} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <p class="para">Productivity is about saving TIME. </p>
                <br />
                <p class="para">
                  {" "}
                  Save time in gathering information, save time in making smart
                  decisions, save time from bad strategic decisions, save time
                  for the more enjoyable parts of business life!
                </p>
                <br />
                <p class="para">
                  Productivity Analysis allows the user to compare the volume of
                  activities with the sales recorded by each sales
                  representative.{" "}
                </p>
                <br />
                <p class="para">
                  {" "}
                  Through the use of filters, users can restrict the analysis to
                  specific activity types, salespersons, time frames, and other
                  useful attributes.
                </p>
                <br />
              </div>
            </div>
            <br />
            <br />
            <br />
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h4>Productivity Analysis Benefits</h4>
                <p class="para">
                  {" "}
                  1. View to-do lists by user and time-frame
                  <br />
                  <br />
                  2. View activities by results and representative
                  <br />
                  <br />
                  3. View incidents by time-frame, priority, volume, and more
                  <br />
                  <br />
                  4. View top opportunities in your pipeline
                  <br />
                  <br />
                  5. View year-to-date quote totals
                  <br />
                  <br />
                </p>
              </div>
              <div class="col-xl-6 cwp4-image ">
                <img src={pa3} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="main-titles-head text-center">
                <h3 class="header-name">
                  BOOST YOUR CRM PRODUCTIVITY WITH THESE {`${project_name}`}{" "}
                  FEATURES
                </h3>
              </div>
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">
                  {" "}
                  Save Time With Full & Easy Email Integration{" "}
                </h3>{" "}
                <br />
                <p class="para">
                  1. Use any email service provider seamlessly with no
                  restrictions
                  <br />
                  <br />
                  2. Save time by automating all incoming and outgoing e-mails
                  <br />
                  <br />
                  3. Access any email thread with one click
                  <br />
                  <br />
                  4. Track all your email communication on one platform and
                  avoid confusion
                  <br />
                  <br />
                </p>
              </div>
              <div class="col-xl-6 cwp4-image ">
                <img src={pa5} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={pa4} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">
                  Minimize Efforts With Practical Visual Tools{" "}
                </h3>{" "}
                <br />
                <p class="para">
                  1. Break down complex processes in simple consecutive steps
                  <br />
                  <br />
                  2. Spot problem areas with more precision
                  <br />
                  <br />
                  3. Create and stores templates to handle similar cases in the
                  future <br />
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">
                  {" "}
                  Use {`${project_name}`} Organization-Wide{" "}
                </h3>{" "}
                <br />
                <p class="para">
                  1. Capabilities to standardize different business work
                  processes
                  <br />
                  <br />
                  2. Encourage collaboration by bringing together
                  customer-facing and other teams on one platform
                  <br />
                  <br />
                  3. Keep everyone in tune with your objectives and the needs of
                  your customers <br />
                  <br />
                </p>
              </div>
              <div class="col-xl-6 cwp4-image ">
                <img src={pa6} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
